import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'
import { preferenceStoreModule } from '@/store/modules/preference'

import AuthRoutes from '@/views/Auth/routes'
import DashboardAuthRoutes, { MENU_DASHBOARD_AUTH } from '@/views/DashboardAuth/routes'
import DashboardLKRoutes, { MENU_DASHBOARD_LK } from '@/views/DashboardLK/routes'
import DashboardCollectorRoutes, { MENU_DASHBOARD_COLLECTOR } from '@/views/DashboardCollector/routes'
import DashboardMarksRoutes, { MENU_DASHBOARD_MARKS } from '@/views/DashboardMarks/routes'
import ErrorRoutes from '@/views/Errors/routes'
import FilesRoutes /* , { MENU_FILES } */ from '@/views/Files/routes'
import FormsHandbookRoutes, { MENU_FORMS_HANDBOOK } from '@/views/FormsHandbook/routes'
import FormDataRoutes, { MENU_FORM_DATA_SETS } from '@/views/FormData/routes'
import FormTemplatesRoutes, { MENU_FORM_TEMPLATE } from '@/views/FormTemplates/routes'
import GroupsRoutes, { MENU_GROUPS } from '@/views/Groups/routes'
import HomeRoutes from '@/views/Home/routes'
import HomeLKRoutes from '@/views/HomeLK/routes'
import LKMunMehRoutes from '@/views/LKMunMeh/routes'
import LKRegMehRoutes from '@/views/LKRegMeh/routes'
import LKNotificationRoutes from '@/views/LKNotificationPages/routes'
import LKReportsRoutes from '@/views/LKReports/routes'
import LKReportsDataCollectionsRoutes from '@/views/LKReportsDataCollections/routes'
import LKRoadmapsFeedRoutes from '@/views/LKRoadmapsFeed/routes'
import LKRoadmapsExpertsRoutes from '@/views/LKRoadmapsExperts/routes'
import LKProfileRoutes from '@/views/LKProfile/routes'
import LKPublicationsRoutes from '@/views/LKPublications/routes'
import LkPassportRoutes from '@/views/LKPassport/routes'
import NotificationBannersRoutes, { MENU_NOTIFICATION_BANNERS } from '@/views/NotificationBanners/routes'
import NotificationPagesRoutes, { MENU_NOTIFICATION_PAGES } from '@/views/NotificationPages/routes'
import NotificationsRoutes from '@/views/Notifications/routes'
import PassportTemplatesRoutes, { MENU_PASSPORT_PAGES } from '@/views/PassportTemplates/routes'
import PassportsList, { MENU_PASSPORTS_LIST } from '@/views/PassportsList/routes'
import ParticipantsRoutes, { MENU_PARTICIPANTS } from '@/views/Participants/routes'
import ParticipantsUsersRoutes from '@/views/ParticipantsUsers/routes'
import PermissionsRoutes, { MENU_PERMISSIONS_PERMISSIONS } from '@/views/Permissions/Permissions/routes'
import PermissionsApplicationsRoutes, { MENU_PERMISSIONS_APPLICATIONS } from '@/views/Permissions/Applications/routes'
import PermissionsInfoModelsRoutes, { MENU_PERMISSIONS_INFOMODELS } from '@/views/Permissions/InfoModels/routes'
import PermissionsPermissionTypesRoutes, { MENU_PERMISSIONS_PERMISSION_TYPES } from '@/views/Permissions/PermissionTypes/routes'
import RoadmapsRoutes, { MENU_ROADMAPS } from '@/views/Roadmaps/routes'

import SessionsRoutes /* , { MENU_SESSIONS } */ from '@/views/Sessions/routes'
import TopicsRoutes, { MENU_TOPICS } from '@/views/Topics/routes'
import UsersRoutes, { MENU_USERS } from '@/views/Users/routes'
import UsersActionsRoutes from '@/views/UsersActions/routes'
import UsersParticipantsRoutes from '@/views/UsersParticipants/routes'
import UsersHistoryRoutes /* , { MENU_USERS_HISTORY } */ from '@/views/UsersHistory/routes'
import PublicationRoutes, { MENU_PUBLICATIONS } from '@/views/Publications/routes'
import TimesheetRoutes, { MENU_TIMESHEET } from '@/views/Timesheet/routes'
import CollectorPublicationRoutes, { MENU_COLLECTOR_PUBLICATIONS } from '@/views/CollectorPublications/routes'
// import OKUCollectorPublicationRoutes, { MENU_OKU_COLLECTOR_PUBLICATIONS } from '@/views/OKUCollectorPublications/routes'
import VPRPublicationRoutes, { VPR_PUBLICATIONS } from '@/views/VPRPublications/routes'
import ProceduresRoutes, { PROCEDURES_PUBLICATIONS } from '@/views/Procedures/routes'
import MarksRoutes, { MENU_MARKS } from '@/views/Marks/routes'
import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'


type Options = Required<CreateRouterOptions>
type RouteConfigFabric = ((o: Options) => RouteConfig[]) | RouteConfig[]

export const registerMenu = (options: Options) => {
  const ctx = preferenceStoreModule.context(options.store)

  return ctx.actions.registerNavigationDrawerMenu([
    MENU_DASHBOARD_AUTH,
    MENU_DASHBOARD_LK,
    MENU_DASHBOARD_COLLECTOR,
    MENU_DASHBOARD_MARKS,
    PROCEDURES_PUBLICATIONS,
    MENU_COLLECTOR_PUBLICATIONS,
    // MENU_OKU_COLLECTOR_PUBLICATIONS,
    VPR_PUBLICATIONS,
    MENU_MARKS,
    MENU_PARTICIPANTS,
    MENU_TOPICS,
    MENU_PUBLICATIONS,
    // MENU_FILES,
    MENU_ROADMAPS,
    MENU_NOTIFICATION_BANNERS,
    MENU_FORM_TEMPLATE,
    MENU_FORMS_HANDBOOK,
    MENU_FORM_DATA_SETS,
    MENU_NOTIFICATION_PAGES,
    MENU_PASSPORTS_LIST,
    MENU_PASSPORT_PAGES,
    MENU_TIMESHEET,
    MENU_USERS,
    // MENU_USERS_HISTORY,
    {
      ...MENU_PERMISSIONS_PERMISSIONS,
      children: [
        MENU_PERMISSIONS_PERMISSIONS,
        MENU_PERMISSIONS_APPLICATIONS,
        MENU_PERMISSIONS_INFOMODELS,
        MENU_PERMISSIONS_PERMISSION_TYPES,
      ],
    },
    MENU_GROUPS,
    // MENU_SESSIONS,
  ])
}

const createGetRoutes = (options: Options, list: RouteConfigFabric[]): RouteConfig[] => {
  const result = list.reduce((acc: RouteConfig[], routes: RouteConfigFabric) => {
    const result2 = typeof routes === 'function' ? routes(options) : routes
    return acc.concat(result2)

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  }, [] as RouteConfig[])

  return result.filter(Boolean).flat()
}

export const createRoutes = (options: Options): RouteConfig[] => (
  createGetRoutes(options, [
    // TODO: что-то с последовательностью регистрации vuex-модулей, так что
    // нужно с начало этот модуль зарегистрировать первый применив createGetRoutes
    createGetRoutes(options, [AuthRoutes]),
    HomeRoutes,
    NotificationsRoutes,

    [
      // Подраздел с префиксом /lk
      {
        path: MENU_FOLDERS.SERVICE_LK.name,
        name: MENU_FOLDERS.SERVICE_LK.route.name,
        redirect: { name: LK_PUBLICATIONS_ROUTES.LAYOUT },
        component: {
          name: 'LayoutLK',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          HomeLKRoutes,
          LKMunMehRoutes,
          LKRegMehRoutes,
          LKReportsRoutes,
          LKReportsDataCollectionsRoutes,
          LKRoadmapsFeedRoutes,
          LKRoadmapsExpertsRoutes,
          LKProfileRoutes,
          LKPublicationsRoutes,
          LkPassportRoutes,
          LKNotificationRoutes,
        ]),
      },

      // Подраздел с префиксом /detach
      {
        path: '/detach',
        name: '/detach',
        // redirect: { name: LK_PUBLICATIONS_ROUTES.LAYOUT },
        component: {
          name: 'LayoutDetach',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          // При необходимости расширения функционала СПУ или сервиса Декодер
          // Достаточно убрать комментарий у того или иного раздела

          // HomeLKRoutes,
          // LKMunMehRoutes,
          // LKRegMehRoutes,
          // LKReportsRoutes,
          // LKRoadmapsFeedRoutes,
          // LKRoadmapsExpertsRoutes,
          // LKProfileRoutes,
          LKPublicationsRoutes,
          // LkPassportRoutes,
          // LKNotificationRoutes,
        ]),
      },

      // Подраздел с префиксом /lk/admin
      {
        path: MENU_FOLDERS.ADMIN_LK.name,
        name: MENU_FOLDERS.ADMIN_LK.route.name,
        redirect: MENU_DASHBOARD_LK.route,
        component: {
          name: 'LayoutAdminLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          ParticipantsRoutes,
          ParticipantsUsersRoutes,
          DashboardLKRoutes,
          TopicsRoutes,
          PublicationRoutes,
          TimesheetRoutes,
          FilesRoutes,
          RoadmapsRoutes,
          NotificationBannersRoutes,
          FormTemplatesRoutes,
          FormsHandbookRoutes,
          FormDataRoutes,
          NotificationPagesRoutes,
          PassportsList,
          PassportTemplatesRoutes,
        ]),
      },

      // Подраздел с префиксом /auth/admin
      {
        path: MENU_FOLDERS.ADMIN_AUTH.name,
        name: MENU_FOLDERS.ADMIN_AUTH.route.name,
        redirect: MENU_DASHBOARD_AUTH.route,
        component: {
          name: 'LayoutAdminAuth',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardAuthRoutes,
          GroupsRoutes,
          PermissionsRoutes,
          PermissionsApplicationsRoutes,
          PermissionsInfoModelsRoutes,
          PermissionsPermissionTypesRoutes,
          SessionsRoutes,
          UsersRoutes,
          UsersActionsRoutes,
          UsersParticipantsRoutes,
          UsersHistoryRoutes,
        ]),
      },

      // Подраздел с префиксом /collector/admin
      {
        path: MENU_FOLDERS.ADMIN_COLLECTOR.name,
        name: MENU_FOLDERS.ADMIN_COLLECTOR.route.name,
        redirect: MENU_DASHBOARD_COLLECTOR.route,
        component: {
          name: 'LayoutCollectorLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardCollectorRoutes,
          CollectorPublicationRoutes,
        ]),
      },
      {
        path: MENU_FOLDERS.ADMIN_COLLECTOR.name,
        name: MENU_FOLDERS.ADMIN_COLLECTOR.route.name,
        redirect: MENU_DASHBOARD_COLLECTOR.route,
        component: {
          name: 'LayoutCollectorLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardCollectorRoutes,
          // OKUCollectorPublicationRoutes,
        ]),
      },
      {
        path: MENU_FOLDERS.ADMIN_COLLECTOR.name,
        name: MENU_FOLDERS.ADMIN_COLLECTOR.route.name,
        redirect: MENU_DASHBOARD_COLLECTOR.route,
        component: {
          name: 'LayoutCollectorLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardCollectorRoutes,
          VPRPublicationRoutes,
        ]),
      },
      {
        path: MENU_FOLDERS.ADMIN_COLLECTOR.name,
        name: MENU_FOLDERS.ADMIN_COLLECTOR.route.name,
        redirect: MENU_DASHBOARD_COLLECTOR.route,
        component: {
          name: 'LayoutCollectorLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardCollectorRoutes,
          ProceduresRoutes,
        ]),
      },

      // Подраздел с префиксом /marks/admin
      {
        path: MENU_FOLDERS.ADMIN_MARKS.name,
        name: MENU_FOLDERS.ADMIN_MARKS.route.name,
        redirect: MENU_DASHBOARD_MARKS.route,
        component: {
          name: 'LayoutCollectorLk',
          render: (h: CreateElement) => h('router-view'),
        },
        children: createGetRoutes(options, [
          DashboardMarksRoutes,
          MarksRoutes,
        ]),
      },
    ],

    // must be last, because in error - `*` route
    ErrorRoutes,
  ])
)
